import { CircularProgress } from "@mui/material";


const CircleLoading = () => {
  
  return (
    <CircularProgress 
        disableShrink
        size={60}
        style={{margin: 'auto', color: '#06C067'}}
    />
  );
};

export default CircleLoading;
